<template>
  <div class="tw-flex tw-flex-col">
    <ChatMessagesBox class="tw-grow tw-w-full" />
    <ChatInputBox
      :is-disabled="isDisabled"
      :disabled-message="disabledMessage"
    />
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import ChatInputBox from '@frontend/ui/features/chat/components/ChatInputBox.vue';
import ChatMessagesBox from '@frontend/ui/features/chat/components/ChatMessagesBox.vue';
import { mapStores } from 'pinia';
import { useChatStore } from '@frontend/ui/stores/chatStore';


export default {
  name: 'Chatbot',
  components: { ChatInputBox, ChatMessagesBox },
  props: ['isDisabled', 'disabledMessage'],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useChatStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>

</style>
